import React from "react";
import { useTranslation } from "react-i18next";
import { Truck, Wrench, ShieldCheck, Sparkles } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function ChiSiamo() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isTrader = user?.account_type === "trader";
  return (
    <div className="pt-28 pb-20 bg-cream min-h-[100svh]" data-testid="about-page">
      {/* Hero */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-12 gap-10 items-center">
        <div className="col-span-12 lg:col-span-6">
          <div className="text-[11px] tracking-[0.3em] uppercase text-slate1">{t("about.pre")}</div>
          <h1 className="mt-4 font-display text-5xl lg:text-6xl font-light text-ink leading-tight">
            {t("about.hero_title_line1")}<br /><span className="italic text-slate1">{t("about.hero_title_em")}</span>
          </h1>
          <p className="mt-6 text-slate1 text-lg leading-relaxed">
            {t("about.p1")}
          </p>
          <p className="mt-4 text-slate1 leading-relaxed">
            {t("about.p2")}
          </p>
        </div>
        <div className="col-span-12 lg:col-span-6">
          <img
            src="https://images.pexels.com/photos/4458210/pexels-photo-4458210.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Blueprints"
            className="w-full h-[520px] object-cover rounded-sm"
          />
        </div>
      </section>

      {/* White Glove */}
      <section id="logistica" className="max-w-[1400px] mx-auto px-6 lg:px-10 mt-28" data-testid="about-logistics">
        <div className="text-[11px] tracking-[0.3em] uppercase text-gold">{t("about.white_glove_pre")}</div>
        <h2 className="mt-4 font-display text-4xl lg:text-5xl font-light text-ink max-w-3xl">
          {t("about.white_glove_title_line1")} <span className="italic text-slate1">{t("about.white_glove_em")}</span>
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { icon: Truck, title: t("about.f1_t"), desc: t("about.f1_d") },
            { icon: Wrench, title: t("about.f2_t"), desc: t("about.f2_d") },
            { icon: ShieldCheck, title: t("about.f3_t"), desc: t("about.f3_d") },
            { icon: Sparkles, title: t("about.f4_t"), desc: t("about.f4_d") },
          ].map((f, i) => (
            <div key={i} className="bg-white border border-ink/10 p-8 rounded-sm hover-lift">
              <f.icon className="text-ink" size={22} />
              <div className="mt-6 font-display text-lg text-ink">{f.title}</div>
              <p className="mt-3 text-sm text-slate1 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Team image */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 mt-28 grid grid-cols-12 gap-10 items-center">
        <div className="col-span-12 lg:col-span-6">
          <img
            src="https://images.unsplash.com/photo-1742440710136-1976b1cad864?w=1000&q=80"
            alt="Studio team"
            className="w-full h-[520px] object-cover rounded-sm"
          />
        </div>
        <div className="col-span-12 lg:col-span-6">
          <div className="text-[11px] tracking-[0.3em] uppercase text-slate1">{t("about.model_pre")}</div>
          <h2 className="mt-4 font-display text-4xl lg:text-5xl font-light text-ink leading-tight">
            {t("about.model_title")}
          </h2>
          <p className="mt-6 text-slate1 leading-relaxed">
            {t("about.model_p")}
          </p>

          <div className="mt-10 grid grid-cols-3 gap-6">
            {(isTrader
              ? [
                  { k: "20+", v: t("about.stat_studios") },
                  { k: "45", v: t("about.stat_cities") },
                  { k: "100%", v: t("about.stat_network") },
                ]
              : [
                  { k: "20+", v: t("about.stat_studios") },
                  { k: "45", v: t("about.stat_cities") },
                  { k: "2%", v: t("about.stat_wallet") },
                ]
            ).map((s, i) => (
              <div key={i}>
                <div className="font-display text-4xl text-ink">{s.k}</div>
                <div className="text-xs tracking-[0.2em] uppercase text-slate1 mt-1">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
